import Light from './Light';
import Dark from './Dark';
import Colors from './Colors';

const QdtThemes = { Light, Dark, Colors };

export default QdtThemes;
export { Light, Dark, Colors };
